export enum StorageKey {
  deliverablesList = 'deliverablesList',
  changeRequestsList = 'changeRequestsList',
  selectedLanguage = 'selectedLanguage',
  projectManagement = 'projectManagement',
  appConfig = 'appConfig',
  isPackageDetailIntentSectionExpanded = 'isPackageDetailIntentSectionExpanded',
}
